"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactGoogleMaps = require("react-google-maps");

var _MarkerClusterer = _interopRequireDefault(require("react-google-maps/lib/components/addons/MarkerClusterer"));

var _conf = _interopRequireDefault(require("../../conf"));

var _translate = _interopRequireDefault(require("../translate"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var themesToShowOutlets = ['landwirtschaft'];

var showOutlets = function showOutlets(theme) {
  return themesToShowOutlets.indexOf(theme) !== -1;
};

var Map = /*#__PURE__*/function (_React$Component) {
  _inherits(Map, _React$Component);

  function Map(props) {
    var _this;

    _classCallCheck(this, Map);

    _this = _possibleConstructorReturn(this, (Map.__proto__ || Object.getPrototypeOf(Map)).call(this, props));
    _this.map = _react.default.createRef();
    _this.state = {
      id: props.activeFarmIdOnMap,
      type: 'farm',
      center: {
        lat: props.latitude,
        lng: props.longitude
      }
    };
    _this.onClick = _this.onClick.bind(_assertThisInitialized(_this));
    _this.handleToggle = _this.handleToggle.bind(_assertThisInitialized(_this));
    _this.handleToggleClose = _this.handleToggleClose.bind(_assertThisInitialized(_this));
    _this.renderMarker = _this.renderMarker.bind(_assertThisInitialized(_this));
    _this.renderInfoWindow = _this.renderInfoWindow.bind(_assertThisInitialized(_this));
    _this.userSettings = {
      zoom: props.zoom,
      lat: props.latitude,
      lon: props.longitude,
      activeId: props.activeFarmIdOnMap
    };
    return _this;
  }

  _createClass(Map, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(prevProps, nextState) {
      if (this.props.locations.length !== prevProps.locations.length) {
        return true;
      }

      return nextState.id !== this.state.id;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var t = this.props.t;
      var locations = this.props.locations || [];
      var locationsWithPosition = locations.filter(function (place) {
        if (!place.location) return false;
        if (!place.location.lat) return false;
        if (!place.location.lon) return false;
        var lat = parseFloat(place.location.lat);
        var lng = parseFloat(place.location.lon);
        return !isNaN(lat) && !isNaN(lng);
      });
      var outletsWithPosition = [];

      if (showOutlets(this.props.theme)) {
        var outlets = this.props.outlets || [];
        outletsWithPosition = outlets.filter(function (place) {
          if (!place.location) return false;
          if (!place.location.lat) return false;
          if (!place.location.lon) return false;
          var lat = parseFloat(place.location.lat);
          var lng = parseFloat(place.location.lon);
          return !isNaN(lat) && !isNaN(lng);
        });
      }

      var center = {
        lat: this.props.latitude,
        lng: this.props.longitude
      };
      return /*#__PURE__*/_react.default.createElement(_reactGoogleMaps.GoogleMap, {
        defaultZoom: this.props.calculatedZoom,
        defaultCenter: center,
        center: this.props.calculatedCenter,
        ref: this.map,
        resetBoundsOnResize: true,
        outletsAll: this.props.outletsAll,
        onZoomChanged: function onZoomChanged() {
          _this2.userSettings.zoom = _this2.map.current.getZoom();
        },
        onCenterChanged: function onCenterChanged() {
          _this2.userSettings.lat = _this2.map.current.getCenter().lat();
          _this2.userSettings.lon = _this2.map.current.getCenter().lng();
        }
      }, this.props.theme === 'vomhof' && /*#__PURE__*/_react.default.createElement("span", {
        className: "outlets-number-box"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "outlets-number-title"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "outlets-title"
      }, t('outlets'))), /*#__PURE__*/_react.default.createElement("span", {
        className: "outlets-number"
      }, this.props.outletsAll.length)), /*#__PURE__*/_react.default.createElement(_MarkerClusterer.default, {
        averageCenter: true,
        enableRetinaIcons: true,
        gridSize: 80,
        minimumClusterSize: 5
      }, locationsWithPosition.map(function (marker) {
        return _this2.renderMarker(marker, 'farm');
      }), outletsWithPosition.map(function (marker) {
        return _this2.renderMarker(marker, 'outlet');
      })));
    }
    /**
     *
     * @param marker
     */

  }, {
    key: "renderMarker",
    value: function renderMarker(marker, type) {
      var _this3 = this;

      var id = marker.id,
          location = marker.location,
          t = this.props.t;
      var lat = parseFloat(location.lat);
      var lng = parseFloat(location.lon);
      return /*#__PURE__*/_react.default.createElement(_reactGoogleMaps.Marker, {
        key: id,
        onClick: function onClick() {
          _this3.handleToggle(id, type);
        },
        noRedraw: true,
        optimized: false,
        icon: {
          url: '/static/assets/images/location.svg',
          scaledSize: new google.maps.Size(50, 50)
        },
        position: {
          lat: lat,
          lng: lng
        }
      }, this.state.id === parseInt(id) && this.state.type === type && this.renderInfoWindow(marker, t));
    }
    /**
     *
     * @param marker
     * @param t
     */

  }, {
    key: "renderInfoWindow",
    value: function renderInfoWindow(marker, t) {
      var _this4 = this;

      var farmname = marker.farmname,
          zip = marker.zip,
          outletNames = marker.outletNames,
          city = marker.city,
          id = marker.id,
          street = marker.street,
          location = marker.location;
      var farmId = marker.farmId;
      farmId = farmId || id;
      var category = '';
      var anchor = '';

      if (marker.category) {
        category = marker.category.name;
        anchor = "#vomhof-outlet-".concat(id);
      }

      var outletsJoined = '';

      if (outletNames && showOutlets(this.props.theme) && outletNames.length > 0) {
        outletsJoined = outletNames.join('\n');
      }

      var _ref = marker.brunch ? marker.brunch : {},
          _ref$soldout = _ref.soldout,
          soldoutValue = _ref$soldout === void 0 ? null : _ref$soldout;

      var lat = parseFloat(location.lat);
      var lng = parseFloat(location.lon);
      return /*#__PURE__*/_react.default.createElement(_reactGoogleMaps.InfoWindow, {
        onCloseClick: this.handleToggleClose,
        position: {
          lat: lat,
          lng: lng
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: 'marker-info-window'
      }, !!soldoutValue === true && /*#__PURE__*/_react.default.createElement("div", {
        className: 'soldout-info-map'
      }, t('soldoutUnavailable')), /*#__PURE__*/_react.default.createElement("div", {
        className: 'heading'
      }, farmname), outletsJoined && /*#__PURE__*/_react.default.createElement("div", {
        className: "outlets"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "addlinebreak"
      }, outletsJoined)), category && /*#__PURE__*/_react.default.createElement("div", {
        className: 'outlets'
      }, category, " - ", city), /*#__PURE__*/_react.default.createElement("div", null, street), /*#__PURE__*/_react.default.createElement("div", null, zip, " ", city), /*#__PURE__*/_react.default.createElement("a", {
        className: 'more-info-map',
        onClick: function onClick(event) {
          return _this4.props.goToFarm(event.ctrlKey || event.metaKey, farmId, _this4.userSettings, anchor);
        }
      }, t('Mehr Informationen'))));
    }
    /**
     *
     * @param e
     */

  }, {
    key: "onClick",
    value: function onClick(e) {
      this.props.onMarkerMoved({
        latitude: e.latLng.lat(),
        longitude: e.latLng.lng()
      });
    }
    /**
     *
     * @param id
     */

  }, {
    key: "handleToggle",
    value: function handleToggle(id, type) {
      this.setState({
        id: parseInt(id),
        type: type
      });
    }
    /**
     *
     */

  }, {
    key: "handleToggleClose",
    value: function handleToggleClose() {
      this.setState({
        id: 0,
        type: ''
      });
    }
  }]);

  return Map;
}(_react.default.Component);

Map.propTypes = {
  t: _propTypes.default.func.isRequired,
  i18n: _propTypes.default.shape({
    language: _propTypes.default.string
  }),
  goToFarm: _propTypes.default.func,
  locations: _propTypes.default.array,
  onMarkerMoved: _propTypes.default.func,
  draggable: _propTypes.default.bool,
  latitude: _propTypes.default.number,
  longitude: _propTypes.default.number,
  pinDraggableUrl: _propTypes.default.string,
  pinNormalUrl: _propTypes.default.string,
  onGeocode: _propTypes.default.func,
  zoom: _propTypes.default.number,
  activeFarmIdOnMap: _propTypes.default.number,
  outlets: _propTypes.default.array,
  theme: _propTypes.default.string,
  outletsAll: _propTypes.default.array,
  calculatedZoom: _propTypes.default.number,
  calculatedCenter: _propTypes.default.shape({
    lat: _propTypes.default.number,
    lng: _propTypes.default.number
  })
};
var LocationMap = (0, _reactGoogleMaps.withScriptjs)((0, _reactGoogleMaps.withGoogleMap)(Map));
LocationMap.defaultProps = {
  locations: _propTypes.default.array,
  draggable: false,
  googleMapURL: _conf.default.googleMapURL
};
LocationMap.propTypes = {
  onMarkerMoved: _propTypes.default.func,
  draggable: _propTypes.default.bool,
  latitude: _propTypes.default.number,
  longitude: _propTypes.default.number,
  locations: _propTypes.default.array,
  outlets: _propTypes.default.array,
  coordsCH: _propTypes.default.shape({
    zoom: _propTypes.default.number,
    latitude: _propTypes.default.number,
    longitude: _propTypes.default.number
  }),
  pinDraggableUrl: _propTypes.default.string,
  pinNormalUrl: _propTypes.default.string,
  googleMapURL: _propTypes.default.string,
  i18n: _propTypes.default.shape({
    language: _propTypes.default.string
  }),
  t: _propTypes.default.func.isRequired,
  goToFarm: _propTypes.default.func,
  activeFarmIdOnMap: _propTypes.default.number,
  theme: _propTypes.default.string,
  calculatedZoom: _propTypes.default.number,
  calculatedCenter: _propTypes.default.shape({
    lat: _propTypes.default.number,
    lng: _propTypes.default.number
  })
};

var _default = (0, _translate.default)(LocationMap);

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./client/components/location-map/index.js
// module id = 671
// module chunks = 0